var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNuls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.045 11.372 2.503 3.467V4.587l4.13 1.688v14.895l-4.402-2.652-8.773-11.88c-.09-.1-.465-.205-1.237.181C7.494 7.204 7.101 8.466 7 9.05v18.12L16.136 31v-6.904l-2.593-3.468v6.814l-4.04-1.658V10.799l6.844 9.346 6.331 3.95c.222-.04.82-.175 1.448-.392.627-.218.944-1.297 1.025-1.81V4.83L16.046 1v10.372z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNuls);
export default __webpack_public_path__ + "static/media/NULS.0630264b31269518de89faa4b8b34fbc.svg";
export { ForwardRef as ReactComponent };